module.exports = __webpack_public_path__ + "img/zoom-minus.8765cb95.svg";